import { streamBedrock, streamSimpleBedrock } from "./providers/amazon-bedrock.js";

export const bedrockProviderModule = {
	streamBedrock,
	streamSimpleBedrock,
};
